import React from 'react'

interface MarketplaceCardProps {
  children: React.ReactNode;
}

export function MarketplaceCards ({ children }: MarketplaceCardProps) {
  return (
    <ul className='grid gap-4 grid-cols-[repeat(auto-fill,minmax(min(100%,18rem),1fr))]'>
      {children}
    </ul>
  )
}
